import React from 'react';
import { Input } from '../../components/ui/input';

// Live-formats money input: "$1,787.00" style ($ prefix + thousand separators).
export const formatMoneyInput = (raw) => {
  if (raw == null) return '';
  const v = String(raw).replace(/[^0-9.]/g, '');
  if (!v) return '';
  const firstDot = v.indexOf('.');
  let int = firstDot >= 0 ? v.slice(0, firstDot) : v;
  const dec = firstDot >= 0 ? v.slice(firstDot + 1).replace(/\./g, '').slice(0, 2) : null;
  int = int.replace(/^0+(?=\d)/, '');
  const withCommas = (int || '0').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return `$${withCommas}${dec != null ? `.${dec}` : ''}`;
};

export const MoneyInput = ({ value, onChange, onBlur, ...props }) => (
  <Input
    type="text"
    inputMode="decimal"
    autoComplete="off"
    value={formatMoneyInput(value)}
    onChange={(e) => onChange(formatMoneyInput(e.target.value))}
    onBlur={(e) => {
      let cleaned = formatMoneyInput(e.target.value).replace(/\.$/, '');
      const m = cleaned.match(/\.(\d)$/);
      if (m) cleaned = `${cleaned}0`;
      if (cleaned !== e.target.value) onChange(cleaned);
      onBlur?.(e);
    }}
    {...props}
  />
);
